// extracted by mini-css-extract-plugin
export var carrierTab = "_57-0";
export var carrierTabActive = "_57-1 _57-0";
export var carrierTabInactive = "_57-2 _57-0";
export var carrierTabLabel = "_57-3";
export var carrierTabLabelActive = "_57-4 _57-3";
export var carrierTabLabelInactive = "_57-5 _57-3";
export var carrierTabPercentage = "_57-6";
export var carrierTabPercentageActive = "_57-7 _57-6";
export var carrierTabPercentageInactive = "_57-8 _57-6";
export var carrierTabWinnable = "_57-9";
export var carrierTabWinnableActive = "_57-a _57-9";
export var carrierTabWinnableInactive = "_57-b _57-9";
export var comparisonContainer = "_57-d";
export var missingRateButton = "_57-n";
export var missingRateButtonActive = "_57-o _57-n";
export var missingRateButtonInactive = "_57-p _57-n";
export var missingRateButtonLabel = "_57-q";
export var missingRateButtonLabelActive = "_57-r _57-q";
export var missingRateButtonLabelInactive = "_57-s _57-q";
export var sidebar = "_57-c";
export var strategyButton = "_57-e";
export var strategyButtonActive = "_57-f _57-e";
export var strategyButtonDescription = "_57-k";
export var strategyButtonDescriptionActive = "_57-l _57-k";
export var strategyButtonDescriptionInactive = "_57-m _57-k";
export var strategyButtonInactive = "_57-g _57-e";
export var strategyButtonLabel = "_57-h";
export var strategyButtonLabelActive = "_57-i _57-h";
export var strategyButtonLabelInactive = "_57-j _57-h";
export var unitToggleButton = "_57-t";
export var unitToggleButtonActive = "_57-u _57-t";
export var unitToggleButtonInactive = "_57-v _57-t";
export var unitToggleButtonLabel = "_57-w";
export var unitToggleButtonLabelActive = "_57-x _57-w";
export var unitToggleButtonLabelInactive = "_57-y _57-w";